const excel = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><rect width="6" height="12.308" x="10" y="1.846"/><path d="M0 1.778v12.445L8.75 16V0zm5.839 9.348-1.074-2.03a1.8 1.8 0 0 1-.126-.417h-.017a3.16 3.16 0 0 1-.144.435l-1.077 2.012H1.727L3.714 8.01 1.897 4.893h1.708l.891 1.869c.07.148.132.323.187.525H4.7c.035-.121.1-.302.196-.543l.99-1.852h1.565l-1.869 3.09 1.921 3.144z"/></svg>',
};

export { excel as default };
